/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolAccountBalanceWalletIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-account-balance-wallet"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M4.85 21.8Q3.75 21.8 2.98 21.02Q2.2 20.25 2.2 19.15L2.2 4.85Q2.2 3.75 2.98 2.98Q3.75 2.2 4.85 2.2L19.15 2.2Q20.25 2.2 21.02 2.98Q21.8 3.75 21.8 4.85L21.8 4.85L12.65 4.85Q11.07 4.85 9.99 5.91Q8.9 6.97 8.9 8.55L8.9 15.45Q8.9 17.02 9.99 18.09Q11.07 19.15 12.65 19.15L21.8 19.15L21.8 19.15Q21.8 20.25 21.02 21.02Q20.25 21.8 19.15 21.8ZM12.65 17.7Q11.7 17.7 11.03 17.05Q10.35 16.4 10.35 15.45L10.35 8.55Q10.35 7.6 11.03 6.95Q11.7 6.3 12.65 6.3L20.5 6.3Q21.45 6.3 22.13 6.95Q22.8 7.6 22.8 8.55L22.8 15.45Q22.8 16.4 22.13 17.05Q21.45 17.7 20.5 17.7ZM16.05 13.5Q16.05 13.5 16.38 13.5Q16.7 13.5 17.13 13.07Q17.55 12.65 17.55 12Q17.55 11.35 17.13 10.93Q16.7 10.5 16.05 10.5Q15.4 10.5 14.97 10.93Q14.55 11.35 14.55 12Q14.55 12.65 14.97 13.07Q15.4 13.5 16.05 13.5Z" fill={color} />
    </svg>
  );
}
